import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { getAdditionalExpensesFields } from '../../constants';
import { SectionProps } from '../../types';
import { FormSection } from './FormSection';

export const AdditionalExpenses = ({ accountingEnvironment, options }: SectionProps) => {
    const showAdditionalExpenses = !useFeatureFlag(FeatureFlag.useSimplifiedAccountingCategoryLogicForRebates);

    const showInvoiceFee =
        useFeatureFlag(FeatureFlag.automatedInvoiceFeeSupported) &&
        !!accountingEnvironment.isAutomatedInvoiceFeeSupported;

    const showSurcharge = !!accountingEnvironment.isPaymentCardSurchargeApplicable;
    const showMulticurrencyFee = useFeatureFlag(FeatureFlag.enableMulticurrencyServiceConfiguration);

    return (
        <FormSection
            items={getAdditionalExpensesFields({
                showAdditionalExpenses,
                showSurcharge,
                showInvoiceFee,
                showMulticurrencyFee,
            })}
            prefix="additionalExpenses"
            options={options}
            titleTextKey={TextKey.AdditionalExpensePlural}
        />
    );
};
